import { movieHighlights } from "@/mocks/siteContent";

export default function MovieSection() {
  return (
    <section id="movie" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-4">
            <i className="ri-movie-2-line" aria-hidden="true"></i>
            电影版看点
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            氛围、镜头与留白，如何改写你对同一故事的感受
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            电影版不一定把故事讲得更全，但它往往把情绪铺得更深。当视听语言开始主导叙事，观众体验到的就不再是「剧情」，而是一种被放大的处境感。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1 rounded-lg overflow-hidden bg-background-200 h-64 lg:h-full min-h-[240px]">
            <img
              src="https://readdy.ai/api/search-image?query=cinematic%20abstract%20art%20of%20a%20dim%20warm%20projector%20beam%20cutting%20through%20soft%20haze%20in%20a%20dark%20room%2C%20deep%20amber%20and%20charcoal%20tones%2C%20painterly%20artistic%20style%2C%20dramatic%20atmospheric%20mood%2C%20no%20text%2C%20editorial%20poster%20aesthetic&width=900&height=1100&seq=nw-movie-01&orientation=portrait"
              alt="电影版氛围示意图"
              title="邻居的妻子电影版看点"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {movieHighlights.map((item) => (
              <article
                key={item.title}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 transition-colors hover:border-primary-300"
              >
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 flex items-center gap-2">
                  <i className="ri-clapperboard-line text-primary-500" aria-hidden="true"></i>
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}